import React from "react";
import biometric from "../../assets/svg/biometric.svg";

function Biometric() {
  return (
    <div className="flex flex-col lg:flex-row items-stretch rounded-[0.75rem] overflow-hidden shadow-[0_32px_48px_-12px_rgba(26,28,30,0.04)] bg-[linear-gradient(179deg,rgba(255,217,123,0.10)_-9.76%,rgba(255,182,0,0.20)_103.24%)]">
      {/* Left content */}
      <div className="flex flex-col justify-center p-[3rem] lg:p-[5rem] flex-1">

        <div className="font-lexend font-[500] text-[#1E191B] text-[1.25rem] lg:text-[2rem] leading-[2.25rem] lg:leading-[3rem]">
          Biometric Check-In &amp; Payout
        </div>

        <div className="mt-[1.5rem] font-lexend font-[400] text-[#7A7493] text-[.75rem] lg:text-[1rem] leading-[1.625rem] lg:leading-[2.03125rem] lg:max-w-[30rem]">
          Eliminate ghost workers &amp; fraud. Validate identities with
          fingerprint and facial recognition directly synced to your payroll
          ledger in real-time.
        </div>
      </div>

      {/* Right panel */}
      <div className="lg:w-[45%] w-full flex-shrink-0 overflow-hidden">
        <img src={biometric} alt="biometric" className="w-full h-[22.5rem] object-cover" />
      </div>
    </div>
  );
}

export default Biometric;
